<style lang="scss" scoped>
  ::v-deep .success-message {
    @apply text-gray-900;
  }
</style>

<template>
  <div>
    <button class="btn btn--primary btn--outline" @click="open">
      {{ campaignCta }}
    </button>
    <portal v-if="isOpen === true" to="modal">
      <div class="fixed inset-0 z-50 flex items-center justify-center overscroll-contain">
        <div @click="close" class="absolute inset-0 bg-gray-800 opacity-[.64]"></div>
        <div ref="form" class="fixed subscribe w-full sm:w-[440px] p-[40px] bg-gray-300 text-gray-800">
          <div class="absolute top-[18px] right-[18px] cursor-pointer select-none text-gray-400 hover:text-gray-800" @click="close"><span v-html="svg('x')" /></div>
          <h3 class="text-gray-900 font-bold mb-md">{{ campaignTitle }}</h3>
          <ValidationObserver ref="observer" tag="form" @submit.prevent="submit('/api/subscribe')">
            <ValidationProvider ref="first_name" vid="first_name" rules="min:2" v-slot="props" :name="translations.first_name" :slim="true">
              <div class="mb-sm group" :class="props.classes">
                <label for="first_name" class="block mb-xxs text-sm font-bold">
                  {{ translations.first_name }}
                  <span class="text-red hidden group-[.required]:inline">*</span>
                </label>
                <input type="text" v-model="formData.first_name" name="first_name" placeholder="Vul hier je voornaam in" class="form__input--filled-400 w-full form__input--lg" />
                <span class="text-red text-xs leading-none inline-block">{{ props.errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider ref="last_name" vid="last_name" rules="min:2" v-slot="props" :name="translations.last_name" :slim="true">
              <div class="mb-sm group" :class="props.classes">
                <label for="last_name" class="block mb-xxs text-sm font-bold">
                  {{ translations.last_name }}
                  <span class="text-red hidden group-[.required]:inline">*</span>
                </label>
                <input type="text" v-model="formData.last_name" name="last_name" placeholder="Vul hier je naam in" class="form__input--filled-400 w-full form__input--lg" />
                <span class="text-red text-xs leading-none inline-block">{{ props.errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="translations.email" :slim="true">
              <div class="mb-sm group" :class="props.classes">
                <label for="email" class="block mb-xxs text-sm font-bold">
                  {{ translations.email }}
                  <span class="text-red hidden group-[.required]:inline">*</span>
                </label>
                <input type="text" v-model="formData.email" name="email" placeholder="Vul hier je e-mailadres in" class="form__input--filled-400 w-full form__input--lg" />
                <span class="text-red text-xs leading-none inline-block">{{ props.errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider ref="newsletter" vid="newsletter" v-slot="props" :rules="{ required: { allowFalse: false } }" :name="translations.newsletter" :slim="true">
              <div class="relative mb-md" :class="props.classes">
                <div class="form__checkbox form__checkbox--filled-dark flex">
                  <input type="checkbox" id="newsletter" :placeholder="translations.newsletter" v-model="formData.newsletter" />
                  <span class="translate-y-[6px]" @click="checkboxSpanClicked"></span>
                  <label ref="newletterlabel" for="newsletter">{{ translations.newsletter }}</label>
                </div>
                <span v-if="props.errors && props.errors.length" class="text-red text-xs leading-none inline-block mb-2">{{ props.errors[0] }}</span>
              </div>
            </ValidationProvider>

            <button type="submit" :disabled="processing" class="w-full btn btn--gray-dark btn--filled flex justify-center">
              <span>{{ translations.submit }}</span>
              <i v-if="processing" class="fa-regular fa-spinner-third animate-spin"></i>
            </button>
            <span v-if="compiledErrors && compiledErrors.length" class="error text-red text-xs leading-none inline-block mb-5">{{ compiledErrors[0] }}</span>
          </ValidationObserver>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
  import formBaseRecaptcha from "@/mixins/formBaseRecaptcha";

  export default {
    name: "campaign-subscribe",

    mixins: [formBaseRecaptcha],

    props: {
      campaignCta: {
        type: String,
        required: true,
      },
      campaignTitle: {
        type: String,
        required: true,
      },
      translations: {
        type: Object,
        default: () => ({
          first_name: "Voornaam",
          last_name: "Naam",
          email: "E-mailadres",
          submit: "Downloaden",
          success_message: "Bedankt om je in te schrijven",
          newsletter: "Ja, ik blijf graag per e-mail op de hoogte van de laatste nieuwtjes, wedstrijden & acties van Pascale Naessens.",
        }),
      },
    },

    data() {
      return {
        formData: {
          first_name: "",
          last_name: "",
          email: "",
          newsletter: false,
          language: document.documentElement.lang,
        },
        isOpen: false,
        recaptchaAction: "newsletterform",
      };
    },

    methods: {
      checkboxSpanClicked() {
        this.$refs.newletterlabel.click();
      },
      close() {
        this.isOpen = false;
      },
      open() {
        this.isOpen = true;
      },
    },
  };
</script>
